import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "evs-expert-agent";
const keys = addTranslations(RESOURCE_NAME, {
    ask_me_anything: {
        en: "Ask anything about Ecovadis",
        fr: "Posez une question sur Ecovadis",
    },
    empty_state_title: {
        en: "Ecovadis coach",
        fr: "Coach Ecovadis",
    },
    title_chip_title: {
        en: "Ecovadis coach",
        fr: "Coach Ecovadis",
    },
    score_response_success: {
        en: "Feedback sent successfully",
        fr: "Feedback envoyé avec succès",
    },
    score_response_error: {
        en: "Feedback not sent",
        fr: "Feedback non envoyé",
    },
    error_message: {
        en: "Something went wrong, and the Ecovadis coach can't continue the conversation. To keep using it, you'll need to reload the page. \n Important: Reloading will erase your current conversation. If there's anything you want to keep, please copy the text and save it elsewhere.",
        fr: "Une erreur inattendue est survenue et le coach Ecovadis ne peut pas continuer la conversation. Pour continuer à l'utiliser, vous devrez recharger la page. \n Important: Le rechargement effacera votre conversation actuelle. Si vous souhaitez conserver quelque chose, veuillez copier le texte et l'enregistrer ailleurs.",
    },
    example_message_chip_assessment: {
        en: "What does the EcoVadis assessment process involve?",
        fr: "En quoi consiste le processus d’évaluation EcoVadis ?",
    },
    example_message_chip_monitoring: {
        en: "What is 360° monitoring?",
        fr: "Qu’est-ce que la veille 360?",
    },
    example_message_chip_living_wage: {
        en: "How is a living wage calculated?",
        fr: "Quelle est la méthode de calcul d’un salaire décent ?",
    },
    example_message_chip_policy: {
        en: "How do you write a good policy for EcoVadis?",
        fr: "Comment rédiger une bonne politique pour Ecovadis?",
    },
});

export function useEvsExpertAgentTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
